"use strict";
/**
 * Runtime-agnostic flag shape data for the language tag UI.
 *
 * Flag emojis don't render reliably across platforms (notably Windows browsers
 * display them as plain two-letter country codes), so PSI renders each flag as
 * a small inline SVG. The teaser bundle uses browser-native SVG and the main
 * client uses `react-native-svg`; both consume the data here and render it
 * with their respective primitives. Keeping the data here means the colors,
 * dimensions and locale → flag mapping are defined once.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.SWISS_CROSS_FLAG = void 0;
exports.getLanguageFlagShape = getLanguageFlagShape;
exports.localeToLanguageFlag = localeToLanguageFlag;
const locale_1 = require("./locale");
exports.SWISS_CROSS_FLAG = {
    viewBox: '0 0 12 12',
    aspect: 1,
    primitives: [
        { kind: 'rect', width: 12, height: 12, fill: '#FF0000' },
        { kind: 'rect', x: 3, y: 5, width: 6, height: 2, fill: 'white' },
        { kind: 'rect', x: 5, y: 3, width: 2, height: 6, fill: 'white' },
    ],
};
const FRENCH_FLAG = {
    viewBox: '0 0 16 12',
    aspect: 0.75,
    primitives: [
        { kind: 'rect', width: 5.33, height: 12, fill: '#002395' },
        { kind: 'rect', x: 5.33, width: 5.33, height: 12, fill: 'white' },
        { kind: 'rect', x: 10.67, width: 5.33, height: 12, fill: '#ED2939' },
    ],
};
const GERMAN_FLAG = {
    viewBox: '0 0 16 12',
    aspect: 0.75,
    primitives: [
        { kind: 'rect', width: 16, height: 4, fill: '#000000' },
        { kind: 'rect', y: 4, width: 16, height: 4, fill: '#DD0000' },
        { kind: 'rect', y: 8, width: 16, height: 4, fill: '#FFCE00' },
    ],
};
const ITALIAN_FLAG = {
    viewBox: '0 0 16 12',
    aspect: 0.75,
    primitives: [
        { kind: 'rect', width: 5.33, height: 12, fill: '#009246' },
        { kind: 'rect', x: 5.33, width: 5.33, height: 12, fill: 'white' },
        { kind: 'rect', x: 10.67, width: 5.33, height: 12, fill: '#CE2B37' },
    ],
};
const UK_FLAG = {
    viewBox: '0 0 16 12',
    aspect: 0.75,
    primitives: [
        { kind: 'rect', width: 16, height: 12, fill: '#012169' },
        { kind: 'path', d: 'M0,0 L16,12 M16,0 L0,12', stroke: 'white', strokeWidth: 2 },
        { kind: 'path', d: 'M0,0 L16,12 M16,0 L0,12', stroke: '#C8102E', strokeWidth: 1 },
        { kind: 'path', d: 'M8,0 V12 M0,6 H16', stroke: 'white', strokeWidth: 3 },
        { kind: 'path', d: 'M8,0 V12 M0,6 H16', stroke: '#C8102E', strokeWidth: 2 },
    ],
};
const DUTCH_FLAG = {
    viewBox: '0 0 16 12',
    aspect: 0.75,
    primitives: [
        { kind: 'rect', width: 16, height: 4, fill: '#AE1C28' },
        { kind: 'rect', y: 4, width: 16, height: 4, fill: 'white' },
        { kind: 'rect', y: 8, width: 16, height: 4, fill: '#21468B' },
    ],
};
const FLAG_BY_SUBTAG = {
    en: UK_FLAG,
    fr: FRENCH_FLAG,
    de: GERMAN_FLAG,
    it: ITALIAN_FLAG,
    nl: DUTCH_FLAG,
};
/** Look up the flag shape for a BCP 47 primary subtag. Returns null for
 *  subtags with no associated flag (e.g. `'rm'`). */
function getLanguageFlagShape(primarySubtag) {
    return FLAG_BY_SUBTAG[primarySubtag] ?? null;
}
/** Extract the primary subtag from a locale string and return it iff a flag
 *  exists for it. `'fr-CH'` → `'fr'`; `'rm-CH'` → `null` (no Romansh flag);
 *  unknown subtags → `null`. */
function localeToLanguageFlag(locale) {
    const subtag = (0, locale_1.localeToLanguageCode)(locale);
    if (subtag && subtag in FLAG_BY_SUBTAG)
        return subtag;
    return null;
}
//# sourceMappingURL=flag-data.js.map